
import React from 'react';
import NavBar from './NavBar';
import FloatingActionButton from './FloatingActionButton';
import { cn } from '@/lib/utils';

interface PageLayoutProps {
  children: React.ReactNode;
  title?: string;
  showBackButton?: boolean;
  onBack?: () => void;
  className?: string;
  fullWidth?: boolean;
  hideNavigation?: boolean; // Prop to control navigation visibility
  noBottomPadding?: boolean; // Prop to remove bottom padding
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  title,
  showBackButton = false,
  onBack,
  className,
  fullWidth = false,
  hideNavigation = false,
  noBottomPadding = false,
}) => {
  const hasCustomBg = className?.includes('bg-');
  return (
    <div 
      className={cn(noBottomPadding ? "" : "pb-16", hasCustomBg ? className : "", hasCustomBg ? "min-h-screen" : "")} 
      style={hasCustomBg && className?.includes('bg-[#f5f5f5]') ? { backgroundColor: '#f5f5f5' } : undefined}
    >
      {(showBackButton || (title && title.trim() !== "")) && (
        <header className="sticky top-0 z-40 bg-background border-b border-border" style={{ boxShadow: '0px 1px 3px 1px #00000012, 0px 1px 2px 0px #00000026' }}>
          <div className={cn(
            "flex items-center h-16 relative",
            !fullWidth && "max-w-4xl mx-auto"
          )}>
            {showBackButton && (
            <button
              onClick={onBack}
                className="mr-2 rounded-full w-8 h-8 flex items-center justify-center hover:bg-muted absolute left-0 top-1/2 -translate-y-1/2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="h-5 w-5"
              >
                <path d="M19 12H5M12 19l-7-7 7-7" />
              </svg>
              <span className="sr-only">Go back</span>
            </button>
            )}
            {title && title.trim() !== "" && (
              <h1
                className="text-2xl font-bold text-center w-full"
                style={{
                  fontFamily: 'Lato',
                  fontWeight: 700,
                  fontStyle: 'bold',
                  fontSize: 18,
                  lineHeight: '26px',
                  letterSpacing: '0.3px',
                  verticalAlign: 'middle',
                  margin: 0
                }}
              >
                {title}
              </h1>
            )}
          </div>
        </header>
      )}
      
      <main className={cn(
        "flex-1",
        !fullWidth && "max-w-4xl mx-auto",
        hasCustomBg ? "p-0" : "p-2 pb-0",
        !hasCustomBg && className
      )}>
        {children}
      </main>
      
      {!hideNavigation && <NavBar />}
    </div>
  );
};

export default PageLayout;
